import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { updateAdMobConsent } from "@/lib/admob";
import { applyConsent, CONSENT_KEY, getStoredConsent, type ConsentChoice } from "@/lib/consent";

export const ConsentBanner = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getStoredConsent() === null) {
      setVisible(true);
    }
  }, []);

  const handleChoice = (choice: ConsentChoice) => {
    try {
      localStorage.setItem(CONSENT_KEY, choice);
    } catch {
      // localStorage unavailable
    }
    applyConsent(choice);
    updateAdMobConsent(choice === "granted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label={t("consent_title")}
      className="fixed bottom-0 left-0 right-0 z-[100] bg-card/95 backdrop-blur-md border-t border-white/[0.08] px-4 py-4 pb-safe animate-fade-in-up"
    >
      <div className="max-w-screen-sm mx-auto space-y-3">
        <p className="text-sm text-muted-foreground leading-relaxed">
          {t("consent_message")}{" "}
          <Link to="/cookies" className="text-secondary underline underline-offset-2">
            {t("consent_learn_more")}
          </Link>
        </p>
        <div className="flex gap-3">
          <Button
            variant="outline"
            size="sm"
            className="flex-1"
            onClick={() => handleChoice("denied")}
          >
            {t("consent_reject")}
          </Button>
          <Button
            size="sm"
            className="flex-1 bg-secondary hover:bg-secondary/90 text-secondary-foreground"
            onClick={() => handleChoice("granted")}
          >
            {t("consent_accept")}
          </Button>
        </div>
      </div>
    </div>
  );
};
